import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { LocationData, LocationParams } from './locations.types';

const getLocationsList = (client: AxiosInstance) => async (params: LocationParams) => {
  return (await client.get<PaginatedApiResponse<LocationData[]>>(API_ROUTES.GET_LOCATION_LIST, { params })).data;
};

export const getLocationDetail = (client: AxiosInstance) => async (locationId: string) => {
  return (
    await client.get<ApiResponse<LocationData>>(API_ROUTES.GET_LOCATION_DETAIL, {
      params: { locationId: locationId || '' },
    })
  ).data;
};

export const locationQueries = {
  all: () => ['locations'],

  list: (params: LocationParams) =>
    queryFactoryOptions<PaginatedApiResponse<LocationData[]>>({
      queryKey: [...locationQueries.all(), 'list', params],
      queryFn: (client) => () => getLocationsList(client)(params),
    }),

  detail: (locationId: string) =>
    queryFactoryOptions<ApiResponse<LocationData>>({
      queryKey: [...locationQueries.all(), 'detail', locationId],
      queryFn: (client: AxiosInstance) => () => getLocationDetail(client)(locationId),
    }),
};
